// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1ad92b8e","455":"16845fda","977":"cc913263"}[chunkId] + ".chunk.js";
};